import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { SliderFilesResource } from 'app/resources/homepage/SliderFilesResource';
import { UtilsService } from 'app/services/utils.service';
import { forkJoin } from 'rxjs';
import { isBreakOrContinueStatement } from 'typescript';
import { KioskListResource } from 'app/models/KioskListResource';
import { FilterCriteriaListEdt } from 'app/models/FilterCriteriaListEdt';
import { KioskResource } from 'app/models/KioskResource';
import { FilterCriteriaEDT } from 'app/models/FilterCriteriaEDT';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SliderFilesAndKioskResource } from 'app/models/SliderFilesAndKioskResource';

@Component({
  selector: 'vbn-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
  providers: [DatePipe]
})
export class SliderComponent implements OnInit {

  sliderType = 'image';
  myFiles4Render: string[] = [];
  myFiles: string[] = [];
  filesToBeSaved: string[];
  myVideos: string[] = [];
  userEmail: string;
  errorMessage: any;
  slider: SliderFilesResource;
  dateNow: Date = new Date();
  noUploadedFiles = 0;

  kiosksList: KioskListResource;
  filterCriteria: FilterCriteriaListEdt;
  checkList: any;
  checkObject: any;
  kioskListResource: KioskResource[];
  arrayToSend: any;
  addressParams: any;
  saveErrors: boolean = false;
  sliderRid: any;

  constructor(private service: UtilsService,
    private translate: TranslateService,
    private _notificationService: NotificationsService,
    private datePipe: DatePipe, private router: Router,
    private activatedRoute: ActivatedRoute,) {
    this.slider = new SliderFilesResource();

    this.kiosksList = new KioskListResource();
    this.kiosksList.list = new Array<KioskResource>();
    this.filterCriteria = new FilterCriteriaListEdt();
    this.filterCriteria.filters = new Array<FilterCriteriaEDT>();
    this.checkList = new Array();
    this.kioskListResource = new Array<KioskResource>();
    this.arrayToSend = new Array();
  }

  ngOnInit() {
    this.userEmail = this.service.currentUserEmail;
    this.getKioskList();
    if (this.router.url != '/add-footer') {
      this.activatedRoute.params.subscribe((params: Params) => {
        if ('json' in params) {
          this.addressParams = JSON.parse(atob(params['json']));
          this.sliderRid = this.addressParams.sliderRid;
          // this.getSliderContent(this.sliderRid);
        }
      });
    }
  }

  getKioskList() {
    this.service.add('/admin/kiosk/getAll?userEmail=' + this.userEmail, this.filterCriteria)
      .subscribe(
        response => {
          this.kiosksList = response;
          if (this.kiosksList.errorCode == 1002) {
            forkJoin(
              [this.translate.get('Error'),
              this.translate.get('0 items found after the search!')]
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'error')
            });
            this.kiosksList = new KioskListResource();
            this.filterCriteria.filters = new Array<FilterCriteriaEDT>();
            this.kiosksList.list = [];
          }
          this.initializationKioskList();
          if (this.sliderRid) {
            this.getSliderContent(this.sliderRid);
          }
        },
        error => this.errorMessage = <any>error);
  }
  initializationKioskList() {
    if (this.kiosksList.list == null) {
      this.kioskListResource = []
    } else {
      this.kioskListResource = this.kiosksList.list;
    }
    this.checkList = new Array();
    for (let i = 0; i < this.kiosksList.list.length; i++) {
      this.checkObject = {};
      this.checkObject.kiosk = new SliderFilesAndKioskResource();
      this.checkObject.kiosk = this.kiosksList.list[i];
      this.checkList.push(this.checkObject);
    }
    this.checkObject = {};
  }

  updateCheckedOptionsKiosk(kiosk, event) {
    if (event.target.checked) {
      let termsOrGdpr = new SliderFilesAndKioskResource()
      termsOrGdpr.kiosk = kiosk;
      this.arrayToSend.push(termsOrGdpr);
    } else {
      for (let i = 0; i < this.arrayToSend.length; i++) {
        if (kiosk.rid == this.arrayToSend[i].kiosk.rid) {
          this.arrayToSend.splice(i, 1);
          return
        }
      }
    }
  }


  getSliderContent(rid, afterDelete = false) {
    this.myFiles = [];
    this.myFiles4Render = [];
    this.myVideos = [];
    let dateS = this.datePipe.transform((new Date()), "dd-MMM-yyyy HH:mm")
    this.service.get(`/admin/slider/get4Admin?id=${rid}`)
      .subscribe(
        response => {
          this.slider = response;
          if (!afterDelete) {
            if (this.slider.photo) {
              this.sliderType = 'image';
            }
            if (this.slider.video) {
              this.sliderType = 'video';
            }
          }
          Object.assign(this.kioskListResource, this.kiosksList)
          if (this.kioskListResource.length > 0) {
            for (let i = 0; i < this.kioskListResource.length; i++) {
              for (let j = 0; j < this.slider.kioskResourceList.length; j++) {
                if (this.slider.kioskResourceList[j].kiosk.rid == this.kioskListResource[i].rid) {
                  for (let k = 0; k < this.checkList.length; k++) {
                    if (this.checkList[k].kiosk.rid == this.kioskListResource[i].rid) {
                      this.checkList[k].check = true;
                      this.arrayToSend.push(this.checkList[k]);
                    }
                  }
                }
              }
            }
          }
        },
        error => this.errorMessage = <any>error);


  }


  getFileDetails(e) {
    this.myFiles = [];
    this.myFiles4Render = [];
    for (var i = 0; i < e.target.files.length; i++) {
      if (e.target.files[i].size >= 30 * 1048576) { //less that 30MB
        forkJoin(
          [this.translate.get('Error'),
          this.translate.get('Image size must be less than 30 MB!')]
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
        });
        return;
      }
      if (this.checkFileExtension(e.target.files[i])) {
        this.myFiles.push(e.target.files[i]);
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.myFiles4Render.push(e.target.result);
        }
        reader.readAsDataURL(e.target.files[i]);


      } else {
        this.myFiles = [];
        this.myFiles4Render = [];
        forkJoin(
          [this.translate.get('Error'),
          this.translate.get('Upload image: jpeg,jpg,png,gif,bitmap,tiff')]
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
        });
        break;
      }
    }
  }

  getVideoDetails(e) {
    this.myVideos = [];
    let sizeLess20Mb = true;
    for (let i = 0; i < e.target.files.length; i++) {
      if (e.target.files[i].size >= 60 * 1048576) { //less that 20MB
        forkJoin(
          [this.translate.get('Error'),
          this.translate.get('Video size must be less than 20 MB!')]
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
        });
        sizeLess20Mb = false;
      }
    }
    if (!sizeLess20Mb) return;
    for (var i = 0; i < e.target.files.length; i++) {
      if (this.checkVideoExtension(e.target.files[i])) {
        this.myVideos.push(e.target.files[i]);
      } else {
        this.myVideos = []
        forkJoin(
          [this.translate.get('Error'),
          this.translate.get('Upload video: webm,mp4')]
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
        });
        break;
      }
    }
  }

  checkFileExtension(file) {
    if (this.sliderType !== 'image') {
      return false;
    }
    if (file.type == "image/jpeg" || file.type == "image/JPEG" || file.type == "image/jpg" || file.type == "image/JPG"
      || file.type == "image/png" || file.type == "image/PNG" || file.type == "image/gif" || file.type == "image/GIF"
      || file.type == "image/bitmap" || file.type == "image/BITMAP" || file.type == "image/bmp" || file.type == "image/BMP") {
      return true;
    }
    return false;
  }

  checkVideoExtension(file) {
    if (this.sliderType !== 'video') {
      return false;
    }
    if (file.type == "video/webm" || file.type == "video/WEBM" || file.type == "video/mp4" || file.type == "video/MP4") {
      return true;
    }
    return false;
  }


  uploadFiles() {

    this.noUploadedFiles = 0;
    if (this.myFiles.length === 0) {
      return;
    }
    for (var i = 0; i < this.myFiles.length; i++) {
      let formData = new FormData();

      formData.append("file", this.myFiles[i]);

      this.service.add(`/admin/slider/uploadPhoto?id=${this.sliderRid}`, formData)
        .subscribe(
          response => {
            if (this.noUploadedFiles === (this.myFiles.length - 1)) {
              this.getSliderContent(this.sliderRid)
              forkJoin(
                [this.translate.get('Success'),
                this.translate.get('Images Uploaded')]
              ).subscribe((res) => {
                this._notificationService.create(res[0], res[1], 'success')
              });
            }
            this.noUploadedFiles = this.noUploadedFiles + 1;
          },
          error => this.errorMessage = <any>error);
    }

  }

  uploadVideos() {
    let formData = new FormData();
    this.noUploadedFiles = 0;
    if (this.myVideos.length === 0) {
      return;
    }
    for (var i = 0; i < this.myVideos.length; i++) {
      formData = new FormData();
      formData.append("file", this.myVideos[i]);
      this.service.add(`/admin/slider/uploadVideo?id=${this.sliderRid}`, formData)
        .subscribe(
          response => {
            if (this.noUploadedFiles === (this.myVideos.length - 1)) {
              this.getSliderContent(this.sliderRid);
              forkJoin(
                [this.translate.get('Success'),
                this.translate.get('Videos Uploaded')]
              ).subscribe((res) => {
                this._notificationService.create(res[0], res[1], 'success')
              });
            }
            return true;
          },
          error => {
            this.errorMessage = <any>error;
            if (this.errorMessage.error.errorCode === 101) {
              forkJoin(
                [this.translate.get('Upload File'),
                this.translate.get('The file size should be max 20MB')]
              ).subscribe((res) => {
                this._notificationService.create(res[0], res[1], 'error')
              });
            }
            return false;
          }
        );

    }
  }

  onSubmit() {
    this.slider.photo = (this.sliderType === 'image') ? true : false;
    this.slider.video = (this.sliderType === 'video') ? true : false;
    this.slider.userEmail = this.slider.userEmail || this.userEmail;

    if (this.slider.rid) {
      if ((this.slider.video && this.slider.videos.list.length === 0 && this.slider.video && this.myVideos.length === 0) ||
        (this.slider.photo && this.slider.photos.list.length === 0 && this.myFiles.length === 0)) {
          console.log('1')
        forkJoin(
          [this.translate.get('Error'),
          this.translate.get('Mising fields')]
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
        });
        return;
      }
    }
    else {
      if ((this.slider.video && this.myVideos.length === 0) ||
        (this.slider.photo && this.myFiles.length === 0)) {
        forkJoin(
          [this.translate.get('Error'),
          this.translate.get('Mising fields')]
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
        });
        return;
      }
    }
    if (this.arrayToSend.length == 0) {
      forkJoin(
        this.translate.get('Mising fields'),
        this.translate.get('Please check at least 1 kiosk!')
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      });
      return;
    }
    (!this.sliderRid) && (this.slider.userEmail = this.userEmail);
    this.slider.kioskResourceList = this.arrayToSend;

    this.service.add(`/admin/slider/edit`, this.slider)
      .subscribe(
        response => {
          this.slider = response;
          this.sliderRid = this.slider.rid;
          if (this.slider.errorCode === 0) {
            if (this.slider.photo && this.myFiles.length > 0) {
              this.uploadFiles();
            } else {
              if (this.slider.video && this.myVideos.length > 0) {
                this.uploadVideos();
              } else {
                this.getSliderContent(this.sliderRid);
                forkJoin(
                  [this.translate.get('Success'),
                  this.translate.get('Slider saved')]
                ).subscribe((res) => {
                  this._notificationService.create(res[0], res[1], 'success')
                });
              }
            }
          }
          // this.router.navigate(['/slider-list/']);

        },
        error => this.errorMessage = <any>error);
  }

  deleteImage(id) {
    this.service.get(`/admin/slider/delete/photo/${id}`)
      .subscribe(
        response => {
          this.getSliderContent(this.sliderRid, true);

          forkJoin(
            [this.translate.get('Success'),
            this.translate.get('Image deleted')]
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'success')
          });
        },
        error => this.errorMessage = <any>error);
  }

  deleteVideo(id) {
    this.service.get(`/admin/slider/delete/video/${id}`)
      .subscribe(
        response => {
          this.getSliderContent(this.sliderRid, true);
          forkJoin(
            [this.translate.get('Success'),
            this.translate.get('Video deleted')]
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'success')
          });
        },
        error => this.errorMessage = <any>error);
  }

  changePosition(direction, media, type) {
    const newPosition = media.position + direction
    this.slider[type].list = this.slider[type].list.map((elem) => {
      if (elem.rid === media.rid) {
        return {
          ...elem,
          position: newPosition
        }
      } else if (elem.position === newPosition && direction === -1) {
        return {
          ...elem,
          position: newPosition + 1
        }
      } else if (elem.position === newPosition && direction === +1) {
        return {
          ...elem,
          position: newPosition - 1
        }
      }
      return elem
    }).sort((a, b) => a.position - b.position)
  }

  showResponsiveDetails(kioskId) {
    const width = window.innerWidth;
    if (width <= 1100) {
      for (let i = 0; i < this.kiosksList.list.length; i++) {
        if (this.kiosksList.list[i].rid == kioskId) {
          this.kiosksList.list[i].showDetailsOnResponsive = !this.kiosksList.list[i].showDetailsOnResponsive;
        }
        else {
          this.kiosksList.list[i].showDetailsOnResponsive = false;
        }
      }
    }
    else {
      return;
    }

  }

  removeImageToBeSaved(index) {
    var filesBuffer = [];
    Array.prototype.push.apply(filesBuffer, this.myFiles4Render);
    for (let i = 0; i < filesBuffer.length; i++) {
      if (i == index) {
        filesBuffer.splice(i, 1)
      }
    }
    this.myFiles4Render = [];
    this.myFiles4Render = filesBuffer;
  }
}
